/**
 * @generated SignedSource<<5ee01bec8d3f6c744747b059c459e176>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_container_Content =
  {
    __typename?: "Content";
    id: string | null;
  };
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
  };
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    type: string;
  };
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location =

    | useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment
    | useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment;
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment =
  {
    __typename?: "Comment";
    container: useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_container_Content;
    location: useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment_location;
  };
export type useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList =
  {
    __typename?: "PaginatedCommentList";
    nodes: Array<useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList_nodes_Comment | null> | null;
  };
export type useCommentQueryParamsCommentLocationQuery_Query = {
  __typename?: "Query";
  comments: useCommentQueryParamsCommentLocationQuery_comments_PaginatedCommentList | null;
};
export type useCommentQueryParamsCommentLocationQueryVariables = Exact<{
  commentId?: InputMaybe<Scalars["ID"]["input"]>;
  contentStatus?: InputMaybe<
    Array<InputMaybe<GraphQLContentStatus>> | InputMaybe<GraphQLContentStatus>
  >;
}>;
export type useCommentQueryParamsCommentLocationQuery =
  useCommentQueryParamsCommentLocationQuery_Query;
